<template>
  <div>
    <div class="news-item" >
      <div  @click="handle"  class="news-item-left"  :class = "{'readed-active' : data.read === '1'}" :style="{'width': data.titleImage ? 'calc(100% - 156px)' : '100%'}">
        <p class="news-item-left-title"> <img v-if="data.topStatus && data.topStatus === '1'" class="topIcon keep-hue" :src="require('@/assets/NewsCenter/topstatus.png')" alt="">
          <span class="title oneRowEllipsis" >{{data.title || '-'}}</span>
          <img class="new keep-hue" v-if="data.isNewNews"   :src="require('@/assets/Home/Index/NewsIndex/newNews.png')"></p>
        </p>
        <p class="news-item-left-desc threeRowEllipsis" style="height: 80px" v-if="data.titleImage || data.contentDesc">{{data.contentDesc || ''}}</p>

      </div>
      <div v-if="data.titleImage" class="news-item-right">
        <img class="keep-hue" :src="data.titleImage.split(',')[0]" />
      </div>
    </div>
    <ListFoot :data="data" class="mt3"/>

  </div>

</template>

<script>
    import ListFoot from "./listFoot";
    export default {
        name: "NewsItemWithPic",
        props: {
            data: { type: Object, default: () => []},
        },
        components: {
            ListFoot
        },
        methods: {
            handle() {
                // 点击设置已读状态
                if(this.data.read !== '1') this.$set(this.data,'read','1');

            }
        }
    }
</script>

<style scoped lang="scss" >
    @import "@/styles/variables.scss";
    .news-item {
        display: flex;
        box-sizing: border-box;
        &-left{
            &.readed-active {
                .news-item-left-title {
                    color: #666666;
                  &:hover {
                    color: $color-primary;
                    cursor: pointer;
                  }
                }
            }
            &-title {
                max-width: 100%;
                color: #111111;
                font-weight: bold;
                font-size: 16px;
                height: 24px;
                line-height: 24px;
                &:hover {
                    color: $color-primary;
                    cursor: pointer;
                }
                display: flex;
                align-items: center;
                img {
                    width: 30px;
                    height: 16px;
                    margin-right: 10px;
                }
                .new {
                    width: 30px;
                    height: 16px;
                    margin-left: 10px;
                }
                .title {
                    flex:1
                }
            }
            &-desc {
                margin-top: 3px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                line-height: 26px;
            }

        }
        &-right {
            width: 140px;
            height: 93px;
            overflow: hidden;
            margin-left: 16px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 6px;
              object-fit: cover;
            }

        }
    }
    @media (max-width: 1719px){
        .news-item-left-title {
            font-size: 16px;
        }

    }

</style>